import { message, Spin, Tabs } from "antd";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { useEffect } from "react";
import { useState, React } from "react";
import "./CostPage.css";
import InvestmentPage from "./InvestmentPage/InvestmentPage";
import ExpensePage from "./ExpensePage/ExpensePage";
import ExpenseByMonthPage from "./ExpenseByMonthPage/ExpenseByMonthPage";

function CostPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [reloadTab3, setReloadTab3] = useState(0);

  const tabList = [
    {
      key: "tab1",
      label: "Investment",
      children: <InvestmentPage/>,
    },
    {
      key: "tab2",
      label: "All Expense",
      children: <ExpensePage/>,
    },
    {
      key: "tab3",
      label: "Expense By Month",
      children: <ExpenseByMonthPage reload_random={reloadTab3}/>,
    },
  ];

  useEffect(() => {
    
  }, []);

  const changeTab = (activeKey) => {
    if (activeKey === "tab3") {
      setReloadTab3(Math.floor(Date.now()))
    }
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <Tabs defaultActiveKey="tab1" type="card" items={tabList} onChange={changeTab}/>
      </Spin>
    </CommonDivWidget>
  );
}

export default CostPage;
